<template>
  <div
    :class="[$style.base, { [$style.hasError]: hasError }]"
    @click="toggle"
  >
    <BaseIcon :name="modelValue ? 'eye-off' : 'eye'" />
  </div>
</template>

<script
  setup
  lang="ts"
>
const props = defineProps<{
  hasError: boolean;
  modelValue: boolean;
}>();

const emit = defineEmits(['update:modelValue']);

const toggle = () => {
  emit('update:modelValue', !props.modelValue);
};
</script>

<style
  lang="scss"
  module
>
.base {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 $spacing;
  cursor: pointer;

  &.hasError {
    right: 20px;
  }
}
</style>
